import { render, staticRenderFns } from "./GlobalConfirm.vue?vue&type=template&id=7c82c9c6&"
import script from "./GlobalConfirm.vue?vue&type=script&lang=js&"
export * from "./GlobalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c82c9c6')) {
      api.createRecord('7c82c9c6', component.options)
    } else {
      api.reload('7c82c9c6', component.options)
    }
    module.hot.accept("./GlobalConfirm.vue?vue&type=template&id=7c82c9c6&", function () {
      api.rerender('7c82c9c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalConfirm.vue"
export default component.exports